// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"63":"02c658de","219":"52b0fb40"}[chunkId] + ".chunk.css";
};